export const ADMIN_API_BASE_ROUTE = '/admin';

// POST only
export const ADD_ORG_ROUTE = '/orgs';
export const getNewOrgLogoPolicy = (orgKey: string | null) =>
  `/org/${orgKey || ':orgKey'}/upload-policy`;

export const adminDisableOrgRoute = (orgId: number | null) => `/org/${orgId || ':orgId'}/disable`;
export const adminSendJobsToIndeedRoute = (orgId: number | null) =>
  `/org/${orgId || ':orgId'}/sendJobsToIndeed`;
export const addJobSourceRoute = (jobId: number | null, source: string | null) =>
  `/job/${jobId || ':jobId'}/sources/${source || ':source'}`;
export const GET_SOURCE_TYPES_ROUTE = '/admin/sourcetypes';

export const adminFacebookAdSetsForJob = (jobId: number | null) =>
  `/ads/facebook/adsets/job/${jobId || ':jobId'}`;

export const accountScoreGenerationLogsForDate = (date: string) =>
  `/account-score-generation-log?date=${date}`;
